import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RowData } from 'src/app/models/collection.interface';

@Component({
  selector: 'app-progress-cell',
  template: `
    <ng-container *ngIf="params?.data">
      <div class="progress-bar-container">
        <mat-progress-bar
          *ngIf="displayProgressBar(params.data)"
          mode="indeterminate"
          color="accent"
          style="width: 100%; height: 50px;">
        </mat-progress-bar>
      </div>

      <span *ngIf="!displayProgressBar(params.data)">
        {{ params.value }}
      </span>
    </ng-container>
  `
})
export class ProgressCellComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  displayProgressBar(data: RowData): boolean {
    // Define the ingestion stages that should show the progress bar
    const ingestingStages = ['started', 'image_extraction', 'text_extraction'];

    // Hide the progress bar if the data is null, undefined, or white spaced
    if (!data?.processing_stage?.trim()) return false;

    // Show the progress bar only if the processing stage matches one of the ingestingStages values
    return ingestingStages.includes(data.processing_stage);
  }
}
